import type { DeepPartial } from "simplytyped";
import z from "zod";
import { getMessageMediaApiUrlMiddleware } from "../../config/config";
import type { ShellPartner } from "../types";

export const partnerZod = z.object({
  accountId: z.string(),
  accountName: z.string(),
  allowLoginUsingSso: z.boolean().nullable(),
  allowRegistration: z.boolean().nullable(),
  description: z.string(),
  documentationUrl: z.string(),
  domainName: z.string().nullable(),
  ecosystem: z.string().nullable(),
  email: z.string().nullable(),
  emailToSmsDomain: z.string().nullable(),
  logoUrl: z.string().url(),
  portalLogoUrl: z.string().url(),
  slug: z.string(),
  supportArticleUrls: z.string().nullable(),
});

export type Partner = z.infer<typeof partnerZod>;

export const MMFetchPartnerURL = `${getMessageMediaApiUrlMiddleware()}/partners/v1/partners`;

export const toShellPartner = (data: unknown): ShellPartner => {
  const parsed = partnerZod.safeParse(data);
  const partnerData = parsed.success
    ? parsed.data
    : (data as DeepPartial<Partner>);

  return {
    portalLogoUrl: partnerData.portalLogoUrl,
  };
};
